module.exports = __webpack_public_path__ + "img/7726a281c1d436eb038f78c6e9048c96.svg";